import { ROUTE_PATHS } from '@/shared/constants/routes';
import { useNavigate } from '@tanstack/react-router';
import React from 'react';

interface ErrorBoundaryProps {
  error?: Error;
  resetError?: () => void;
}

/** 라우트 에러 화면 — 디자인 시스템 미정, 기본 Tailwind 스타일 */
export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({
  error,
  resetError,
}) => {
  const navigate = useNavigate();

  const handleReload = () => {
    if (resetError) resetError();
    else window.location.reload();
  };

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="flex w-full max-w-lg flex-col items-center gap-4 rounded-xl border border-gray-200 bg-white p-8 text-center">
        <h2 className="text-xl font-semibold">페이지를 불러올 수 없습니다</h2>
        <p className="text-gray-500">
          요청하신 페이지를 불러오는 중 오류가 발생했습니다.
        </p>
        {error && (
          <p className="w-full rounded-md bg-red-50 p-3 text-sm text-red-600">
            {error.message || '알 수 없는 오류가 발생했습니다.'}
          </p>
        )}
        <div className="flex gap-2">
          <button
            type="button"
            className="rounded-md bg-gray-900 px-4 py-2 text-sm text-white"
            onClick={() => navigate({ to: ROUTE_PATHS.USERS })}
          >
            홈으로 이동
          </button>
          <button
            type="button"
            className="rounded-md border border-gray-300 px-4 py-2 text-sm"
            onClick={handleReload}
          >
            다시 시도
          </button>
        </div>
      </div>
    </div>
  );
};
